import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductGrid.css';
import { FaStar, FaCartPlus } from 'react-icons/fa';
import { FaRegStar } from 'react-icons/fa';
import { useCart } from './Cart'; // Import the useCart hook
import AOS from "aos";
import "aos/dist/aos.css";

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cartItems, addToCart } = useCart(); // Use cart context
  const navigate = useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0);
      AOS.init();
      AOS.refresh();
    }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products`);
        const data = await response.json();
        setProducts(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i < rating ? <FaStar key={i} /> : <FaRegStar key={i} />);
    }
    return stars;
  };

  const handleAddToCart = (product, e) => {
    e.stopPropagation();
    
    const isInCart = cartItems.some(item => item.id === product.id);
    
    if (!isInCart) {
      // Add to cart using context
      addToCart({
        id: product.id,
        name: product.product_title,
        price: product.price,
        image: `${process.env.REACT_APP_BASE_URL}/uploads/${product.image1}`,
        color: 'default',
        size: 'default'
      }, 1);
    } else {
      // Optionally remove from cart or just toggle the button state
      // For now, we'll just keep it as "ADDED" when in cart
      console.log('Item already in cart');
    }
  };

  const handleCardClick = (product) => {
    const searchParams = new URLSearchParams({ id: product.id }).toString();
    navigate(`/product-details?${searchParams}`);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="shop-container">
     <div className="banner-dest">
        <div className="banner-sect">
          <p className='banner-title'>Shop</p>
        </div>
      </div>
      <div className="product-row">
        {products.map((product) => {
          const isInCart = cartItems.some(item => item.id === product.id);
          
          return (
            <div key={product.id} className="product-col">
              <div className="product-card" onClick={() => handleCardClick(product)}>
                <div className="product-img-container">
                  <a
                    href={`${process.env.REACT_APP_BASE_URL}/products/${product.id}`}
                    className="product-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    <img
                      className="primary-img"
                      src={`${process.env.REACT_APP_BASE_URL}/uploads/${product.image1}`}
                      alt={product.product_title}
                    />
                    <img
                      className="hover-img"
                      src={`${process.env.REACT_APP_BASE_URL}/uploads/${product.image2}`}
                      alt={product.product_title}
                    />
                  </a>
                </div>

                <div className="product-details">
                  <h3 className="product-name">
                    <a
                      href={`${process.env.REACT_APP_BASE_URL}/product-details/${product.id}`}
                      onClick={(e) => e.preventDefault()}
                    >
                      {product.product_title}
                    </a>
                  </h3>
                  <div className="product-price">${product.price}</div>
                  <ul className="product-rating">
                    {renderStars(product.rating)}
                    <li>({product.reviews})</li>
                  </ul>
                  <button
                    className={`cart-btn ${isInCart ? 'added' : ''}`}
                    onClick={(e) => handleAddToCart(product, e)}
                  >
                    <FaCartPlus /> {isInCart ? 'ADDED' : 'Add to cart'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductGrid;